
import { Box, Divider, Grid } from '@mui/material';

const RenderDivider = () => <Grid container style={{padding: '32px 16px 20px 16px'}}>
    <Divider variant="middle" style={{ background: '#CED3D9', opacity: 0.3, flex: 1, margin: 0 }} />
</Grid>

export default RenderDivider